// Accordion Trigger Controller
// Opens a remote accordion by its element ID
//
// Usage:
//   <button data-controller="ui--accordion-trigger"
//           data-ui--accordion-trigger-target-id-value="edit-bom-item-123"
//           data-action="click->ui--accordion-trigger#open">
//     Edit
//   </button>
//
//   <div id="edit-bom-item-123" data-controller="ui--accordion">
//     ...
//   </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetId: String,
  }

  open(event) {
    event.preventDefault()

    const targetElement = document.getElementById(this.targetIdValue)
    if (!targetElement) {
      console.warn(`Accordion target not found: #${this.targetIdValue}`)
      return
    }

    // Get the accordion controller from the target element
    const accordionController =
      this.application.getControllerForElementAndIdentifier(
        targetElement,
        "ui--accordion",
      )

    if (accordionController) {
      accordionController.open()
      // Scroll the form into view
      targetElement.scrollIntoView({ behavior: "smooth", block: "nearest" })
    } else {
      console.warn(`Accordion controller not found on #${this.targetIdValue}`)
    }
  }

  close(event) {
    event.preventDefault()

    const targetElement = document.getElementById(this.targetIdValue)
    if (!targetElement) return

    const accordionController =
      this.application.getControllerForElementAndIdentifier(
        targetElement,
        "ui--accordion",
      )

    if (accordionController) {
      accordionController.close()
    }
  }

  toggle(event) {
    event.preventDefault()

    const targetElement = document.getElementById(this.targetIdValue)
    if (!targetElement) return

    const accordionController =
      this.application.getControllerForElementAndIdentifier(
        targetElement,
        "ui--accordion",
      )

    if (accordionController) {
      accordionController.toggle()
    }
  }
}
